import React from 'react';
import { DateInput, Grid, GridItem, Heading, TextInput, typography } from '@digitools/honest-ui';
import useExperience from '../../../hooks/useExperience';
import useTranslate from '../../../hooks/useTranslate';
import useAsDataContext from '../hooks/useAsDataContext';
import { middleInitialMask } from '../../eoi/utils/InputMasks';
import useAuthentication from 'src/hooks/useAuthentication';
import { Experience } from 'src/types/Experience';
import { validateNameStr, validateDateIsOnOrBeforeTodayStr } from '../utils/validationUtils';
import { halfWidth, quarterWidth } from './LayoutComponents';
import { PersonalInformationText } from '../constants/PersonalInformationText';
import { AsText } from '../constants/Text';
import { Language } from 'src/types/Language';
/**
 * Section of fields for personal information, for use within a <Form>
 */
const PersonalInformation = () => {
    const { user } = useAuthentication();
    const { t } = useTranslate();
    const { experience, language } = useExperience();
    const { claimantData } = useAsDataContext();
    const isEnglish = language === Language.ENGLISH;
    return (<div data-public={true} data-testid='personal-information' className='hui-mb-xl-2'>
      {/* TODO(honest-ui gap): Heading needs a size prop; using inline typography overrides */}
      <Heading as='h4' weight='bold' className='hui-mb-md' style={{ fontSize: typography.fontSize.lg, lineHeight: typography.lineHeight.xl }}>
        {t(PersonalInformationText.personalInfoHeading)}
      </Heading>
        <Grid noGutter style={{ rowGap: '0.5rem' }}>
          <GridItem {...quarterWidth} data-private={true}>
            <TextInput data-testid='firstName' label={t(PersonalInformationText.firstNameQuestionLabel)} name={'claimantData.empFirstName'} required={true} validate={(value) => validateNameStr(value, PersonalInformationText.firstNameQuestionLabel, language)} defaultValue={claimantData?.empFirstName || (experience === Experience.EMPLOYEE ? user?.firstName : undefined)} data-private={true}/>
          </GridItem>
          <GridItem {...quarterWidth}>
            <TextInput data-testid='middleInitial' label={t(PersonalInformationText.middleInitialQuestionLabel) + t(AsText.optionalText)} name={'claimantData.empMiName'} transform={middleInitialMask} defaultValue={middleInitialMask(claimantData?.empMiName)} data-private={true}/>
          </GridItem>
          <GridItem {...halfWidth} data-private={true}>
            <TextInput disabled={experience === Experience.EMPLOYEE} data-testid='lastName' label={t(PersonalInformationText.lastNameQuestionLabel)} name={'claimantData.empLastName'} required={true} validate={(value) => validateNameStr(value, PersonalInformationText.lastNameQuestionLabel, language)} defaultValue={claimantData?.empLastName || (experience === Experience.EMPLOYEE ? user?.lastName : undefined)} data-private={true}/>
          </GridItem>
          <GridItem {...quarterWidth} data-private={true}>
            <DateInput data-testid='dateOfBirth' id='empBthDte' name={'claimantData.empBthDte'} label={t(PersonalInformationText.dateOfBirthQuestionLabel) + t(AsText.optionalText)} validate={(date) => validateDateIsOnOrBeforeTodayStr(date, PersonalInformationText.dateOfBirthQuestionLabel, language)} defaultValue={claimantData?.empBthDte} data-private={true}/>
          </GridItem>
        </Grid>
    </div>);
};
export default PersonalInformation;
